import Error from '../model/Error.js';
import MemberCredit from '../dto/MemberCredit.js';
import axios from 'axios';

export default class MemberCreditRepository {
    static findByMember(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/credits`)
                .then((response) => resolve(response.data.data.map((memberCredit) => MemberCredit.fromData(memberCredit))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findActiveGroupedByMember(memberId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/members/${memberId}/credits/grouped-credits`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
